// extracted by mini-css-extract-plugin
export var games = "games-module--games--Stt6s";